import styled from 'styled-components';
import { fontGraphie } from '../../../../fonts/mixin';
import * as C from "../../../components/loggedout/shared-styles/Colors";

export const ComponentContainer = styled.div`
  height:70vh;
  margin-top: 6rem;
`

export const SkipCta = styled.span`
  position: absolute;
  top: -3.4rem;
  right: 3rem;
  padding: 0.5rem;
  text-decoration: underline;
  color: ${C.crystalPurple};
  ${fontGraphie(2.8, 1.8, 6)}
  cursor: pointer;
`;